
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Header from "./Header";
import Home from "./components/front";
import Pricing from "./components/pricing";
import AboutUs from "./components/about-us";
import Footer from "./components/footer";
import Bookappointment from "./components/book-appointment";
import Trea_injection from "./components/trea-injection";
import Details from "./components/details";
import FormBoarding from "./pages/Home";
import Login from "./components/AuthLayout/Login";
import SignUp from "./components/AuthLayout/SignUp";
import Dashboard from "./components/dashboard";
import EditProfile from "./components/EditProfile";
import { UserProvider } from "./store/UserContext";

const App = () => {
  return (
    <UserProvider>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/components/pricing" element={<Pricing />} />
          <Route path="/components/about-us" element={<AboutUs />} />
          <Route path="/components/Bookappointment" element={<Bookappointment />} />
          {/* Treatment dropdown routes */}
          <Route path="/components/trea-injection" element={<Trea_injection />} />
          <Route path="/components/details" element={<Details />} />
          <Route path="/pages/Home" element={<FormBoarding />} />
          {/* Auth routes */}
          <Route path="/auth/login" element={<Login />} />
          <Route path="/auth/signup" element={<SignUp />} />
          {/* Dashboard route */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile/edit" element={<EditProfile />} />
        </Routes>
        {/* Global toast host so notifications survive route changes */}
        <ToastContainer position="top-right" autoClose={2500} hideProgressBar />
        <Footer />

      </BrowserRouter>
    </UserProvider>
  );
};

export default App;
